export const FETCH_NEWSLETTERS = 'newsletter/FETCH_NEWSLETTERS'
export const FETCH_NEWSLETTERS_SUCCESS = 'newsletter/FETCH_NEWSLETTERS_SUCCESS'
export const FETCH_NEWSLETTERS_FAILURE = 'newsletter/FETCH_NEWSLETTERS_FAILURE'
export const RESET_NEWSLETTERS = 'newsletter/RESET_NEWSLETTERS'

export const FETCH_NEWSLETTER = 'newsletter/FETCH_NEWSLETTER'
export const FETCH_NEWSLETTER_SUCCESS = 'newsletter/FETCH_NEWSLETTER_SUCCESS'
export const FETCH_NEWSLETTER_FAILURE = 'newsletter/FETCH_NEWSLETTER_FAILURE'
export const RESET_NEWSLETTER = 'newsletter/RESET_NEWSLETTER'

export const CREATE_NEWSLETTER = 'newsletter/CREATE_NEWSLETTER'
export const CREATE_NEWSLETTER_SUCCESS = 'newsletter/CREATE_NEWSLETTER_SUCCESS'
export const CREATE_NEWSLETTER_FAILURE = 'newsletter/CREATE_NEWSLETTER_FAILURE'
export const RESET_CREATE_NEWSLETTER = 'newsletter/RESET_CREATE_NEWSLETTER'

export const UPDATE_NEWSLETTER = 'newsletter/UPDATE_NEWSLETTER'
export const UPDATE_NEWSLETTER_SUCCESS = 'newsletter/UPDATE_NEWSLETTER_SUCCESS'
export const UPDATE_NEWSLETTER_FAILURE = 'newsletter/UPDATE_NEWSLETTER_FAILURE'
export const RESET_UPDATE_NEWSLETTER = 'newsletter/RESET_UPDATE_NEWSLETTER'

export const DELETE_NEWSLETTER = 'newsletter/DELETE_NEWSLETTER'
export const DELETE_NEWSLETTER_SUCCESS = 'newsletter/DELETE_NEWSLETTER_SUCCESS'
export const DELETE_NEWSLETTER_FAILURE = 'newsletter/DELETE_NEWSLETTER_FAILURE'
export const RESET_DELETE_NEWSLETTER = 'newsletter/RESET_DELETE_NEWSLETTER'


// WEBPACK FOOTER //
// ./src/store/newsletter/actionTypes.js